/**
 * Product types (known by the backend)
 */
export enum ProductType {
  Unknown = 'Unknown',
  AmbientSensor = 'AmbientSensor',
  ApartmentScreen = 'ApartmentScreen',
  CenterUnit = 'CenterUnit',
  SmokeDetector = 'SmokeDetector',
  WaterMeter = 'WaterMeter'
}
